module.exports = __webpack_public_path__ + "img/email-verify-emedia.d82092f6.png";